export function helpNumber(v: string): number {
    if (v.length === 0) {
      return 0;
    }
  
    // Remove os pontos de milhar e substitui a vírgula decimal por ponto
    v = v.replace(/\./g, '').replace(',', '.').replace('%', '');
  
    return Number(v);
  }